import {
  Form,
  useNotify,
  useRecordContext,
  usePermissions,
  useRefresh
} from "react-admin";
import { Delete, Cancel, Save } from "@mui/icons-material";
import {
  Dialog,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import useToggle from "../../ra/hook/useToggle";
import useForRequest from "../../ra/hook/useForRequest";
import Button from "../buttons/button";

function DeletePassportPhysicalButton()
{
  const record = useRecordContext();
  const refresh = useRefresh();
  const notify = useNotify();
  const { on, toggle } = useToggle();
  const { loading, action } = useForRequest();
  const { permissions } = usePermissions();

  const handleClick = (e) =>
  {
    e.stopPropagation();
    toggle();
  };

  const handleCloseClick = (e) =>
  {
    e.stopPropagation();
    toggle();
  };

  const handleSubmit = async () =>
  {
    var url = `customer-passport-physical/${record.id}`;
    const { error } = await action(url, 'DELETE', {});
    if (error)
    {
      notify(error.response.data.error, { type: "error" });
      return;
    }

    refresh();
    toggle();
    notify('Item excluído com sucesso!', { type: "success" });
  };

  if (permissions && permissions.is_master === true)
    return (
      <>
        <Button onClick={handleClick} color="error" label="DELETAR">
          <Delete />
        </Button>

        <Dialog
          fullWidth
          open={on}
          onClose={handleCloseClick}
          aria-label="Excluir Item">
          <Form onSubmit={handleSubmit}>
            <DialogTitle>
              Tem certeza que deseja excluir esse item?
            </DialogTitle>
            <DialogActions>
              <Button
                label="Cancelar"
                disabled={loading}
                color="error"
                onClick={handleCloseClick}>
                <Cancel />
              </Button>
              <Button
                label="Confirmar"
                color="success"
                type="submit"
                disabled={loading}>
                <Save />
              </Button>
            </DialogActions>
          </Form>
        </Dialog>
      </>
    );
  else
    return null;
}

export default DeletePassportPhysicalButton;
